import React, { useContext } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { ThemeContext } from 'providers/ThemeProvider';
import { Header } from 'components/theme';
import { Container, Button } from 'components/common';
import dev from 'assets/illustrations/undraw_science_fqhl.svg';
import { Wrapper, IntroWrapper, Details, Thumbnail } from './styles';

export const Intro = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <Wrapper>
      <Header />
      <IntroWrapper as={Container}>
        <Details theme={theme}>
          <h1>Agencija Za Hemikalije</h1>
          <h4 style={{ fontSize: '1.5rem', lineHeight: 1.2 }}>
            Ekspert saradnik u upravljanju hemikalijama i biocidima u Republici Srbiji.
          </h4>
          <Button as={AnchorLink} href="#contact">
            Zakažite Besplatne Konsultacije
          </Button>
        </Details>
        <Thumbnail>
          <img src={dev} alt="Ja sam Ivana, ekspert u upravljanju hemikalijama i biocidima." />
        </Thumbnail>
      </IntroWrapper>
    </Wrapper>
  );
};
